import { render, staticRenderFns } from "./DateAttribute.vue?vue&type=template&id=72f8cd28&scoped=true&"
import script from "./DateAttribute.vue?vue&type=script&lang=js&"
export * from "./DateAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f8cd28",
  null
  
)

export default component.exports